import React from 'react';

const items = [
  {
    q: 'What is Moro?',
    a: (
      <>
        <p>
          Moro is a simple grounding app that gives everyone the same daily task — something small and meaningful,
          like "call your mom" or "stretch for two minutes." It’s a way to slow down, reset, and feel accomplished every day.
        </p>
      </>
    ),
  },
  {
    q: 'How does it work?',
    a: (
      <>
        <p>
          Every morning, Moro shares one global task with all users. You complete it whenever you like.
        </p>
        <p>
          You can also choose to add more tasks from categories like wellness, creativity, or kindness if you want a little extra motivation.
        </p>
      </>
    ),
  },
  {
    q: 'Why only one task a day?',
    a: (
      <>
        <p>
          Because one small step is often all it takes to feel centered again.
        </p>
        <p>
          Moro is designed to cut through overwhelm and help you focus on simple wins — not endless checklists.
        </p>
      </>
    ),
  },
  {
    q: 'Who is Moro for?',
    a: (
      <>
        <p>
          Anyone who feels busy, distracted, or disconnected — students, professionals, parents, creators — anyone who wants to feel a bit more grounded and present in their day.
        </p>
      </>
    ),
  },
  {
    q: 'Can I customize my experience?',
    a: (
      <>
        <p>
          Yes! While everyone gets the same global daily task, you can choose your preferred categories (like self-care, organization, connection, or productivity) and receive optional extra tasks.
        </p>
      </>
    ),
  },
  {
    q: 'What kind of tasks will I get?',
    a: (
      <>
        <p>Simple, uplifting, and doable things like:</p>
        <ul className="faq-list-examples">
          <li>"Tidy your desk."</li>
          <li>"Take three deep breaths."</li>
          <li>"Text someone thank you."</li>
          <li>"Go outside for five minutes."</li>
        </ul>
        <p>
          Nothing overwhelming — just small actions that help you reset and refocus.
        </p>
      </>
    ),
  },
  {
    q: 'Is Moro a productivity app?',
    a: (
      <>
        <p>Not exactly — it’s more of a grounding app.</p>
        <p>Moro isn’t about doing more; it’s about feeling better about what you do.</p>
      </>
    ),
  },
  {
    q: 'Is Moro free?',
    a: (
      <>
        <p>Moro will always include a free daily task for everyone.</p>
        <p>
          Optional premium features (like category unlocks, journaling, or streak tracking) may be available in the future.
        </p>
      </>
    ),
  },
  {
    q: 'Why is it called “Moro”?',
    a: (
      <>
        <p>"Moro" comes from the idea of tomorrow and more mindful moments.</p>
        <p>It’s a reminder that small steps today make for calmer, more connected tomorrow.</p>
      </>
    ),
  },
];

export default function FAQ() {
  return (
    <section className="faq" id="faq">
      <div className="container">
        <div className="faq-grid">
          <div className="faq-swirls" aria-hidden="true">
            <h2 className="section-title faq-title">Frequently Asked Questions</h2>
            <svg viewBox="0 0 400 220">
              <defs>
                <linearGradient id="swirlGrad" x1="0" x2="1" y1="0" y2="1">
                  <stop offset="0%" stopColor="var(--primary)" />
                  <stop offset="100%" stopColor="var(--accent)" />
                </linearGradient>
              </defs>
              <path d="M30 180 C80 120 110 220 150 170 C190 120 220 230 270 170 C310 120 350 150 370 130" fill="none" stroke="url(#swirlGrad)" strokeWidth="18" strokeLinecap="round" opacity="0.4" />
              <path d="M30 90 C60 60 100 120 130 100" fill="none" stroke="url(#swirlGrad)" strokeWidth="18" strokeLinecap="round" opacity="0.4" />
            </svg>
          </div>
          <div className="faq-list">
            {items.map((item, i) => (
              <details className="faq-item" key={i}>
                <summary>{item.q}</summary>
                <div className="faq-content">{item.a}</div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}